import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import {
  RouterStateSerializer,
  StoreRouterConnectingModule
} from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { SharedModule } from '@ot/dashboard/features/shared';
import { ENVIRONMENT } from '@ot/shared/model';
import { NavbarModule } from '@ot/shared/navbar';
import {
  CustomRouterSerializer,
  effects,
  ErrorHandlerService,
  HttpAuthInterceptorService,
  HttpErrorInterceptorService,
  NotificationModule,
  reducers,
  STORAGE
} from '@ot/shared/utils';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  imports: [
    AppRoutingModule,
    SharedModule,
    StoreRouterConnectingModule.forRoot({
      stateKey: 'ngrxRouter' // name of reducer key
    }),
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(effects),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    NavbarModule,
    NotificationModule
  ],
  exports: [AppRoutingModule, NavbarModule, NotificationModule],
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: STORAGE, useValue: window.localStorage },
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptorService,
      multi: true
    },
    { provide: RouterStateSerializer, useClass: CustomRouterSerializer }
  ]
})
export class CoreModule {}
